import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import EyeOffOutlineIcon from "@iconify/icons-mdi/eye-off-outline";
import EyeOutlineIcon from "@iconify/icons-mdi/eye-outline";
import { InlineIcon } from "@iconify/react";

interface MyDocumentsDocumentVisibilityProps {
  visibility: boolean;
}

export const MyDocumentsDocumentVisibility = ({
  visibility,
}: MyDocumentsDocumentVisibilityProps) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center">
      <InlineIcon
        id="eyeOutline"
        icon={visibility ? EyeOutlineIcon : EyeOffOutlineIcon}
        width="24px"
        color="#4D4D4D"
      />
      <Box width="8px" />
      <Typography variant="caption" color="#5E6366">
        {visibility ? t("MY_DOCUMENTS_EMPLOYEE_VISIBILITY") : t("MY_DOCUMENTS_EMPLOYEE_UNVISIBILITY")}
      </Typography>
    </Box>
  );
};

export default MyDocumentsDocumentVisibility;
